const leftMenuWidthReducer = (state = 418, action) => {
    switch (action.type) {
      case "SET_LEFT_MENU_WIDTH":
        return action.payload;
      default:
        return state;
    }
  }
  export default leftMenuWidthReducer;